<template>
  <div class="content">
    <div class="content__title content__title--party">
      <h1 class="title title--big title--theme">Календарь мероприятий</h1>
    </div>
    <div class="content__tabs">
      <div class="tabs-list">
        <ul class="tabs-list__body">
          <li class="tabs-list__item">
            <router-link :to="{ name: 'events' }" exact-active-class="tabs-list__link--active"
                         class="tabs-list__link">Анонсы мероприятий
            </router-link>
          </li>
          <li class="tabs-list__item">
            <router-link :to="{ name: 'calendar' }" exact-active-class="tabs-list__link--active"
                         class="tabs-list__link">Сдача отчетности
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <router-view class="content__body"/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'InfoLayout',
  computed: {
    regionOrgName() {
      return this.$store.state.organizationName
    },
    userRole() {
      return this.$store.state.userRole
    }
  },
}
</script>
<style lang="sass">
.fade-enter-active, .fade-leave-active
  transition: opacity 0.5s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
